module.exports = __webpack_public_path__ + "static/img/icon-c-email.3c24727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-email.png
// module id = 4MoV
// module chunks = 21